// extracted by mini-css-extract-plugin
module.exports = {"container":"N7HAyFcL","eventTypeWrapper":"ChT3rszO","headlineWrapper":"g6Bqww3z","situationWrapper":"remeIuP2"};